module.exports = __webpack_public_path__ + "img/pendapatan.4ec65f42.jpg";